<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' ,fullScreenBackdrop:true}">
</ngx-loading>
<div class="wrapper">
    <app-sidebar></app-sidebar>
    <app-header></app-header>

    <div class="page-wrapper">
        <div class="page-content">
            <!--breadcrumb-->
            <div class="page-breadcrumb d-none d-sm-flex align-items-center mb-4">
                <!-- <div class="breadcrumb-title pe-3">App Version</div> -->
                <div class="ps-3">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb mb-0 p-0">
                            <li class="breadcrumb-item"><a href="javascript:void(0)" routerLink="/dashboard"><i class="bx bx-home-alt"></i></a>
                            </li>
                            <!-- <li class="breadcrumb-item active" aria-current="page">App Version</li> -->
                        </ol>
                    </nav>
                </div>
            </div>
            <!--end breadcrumb-->

            <div class="row">
                <div class="col-xl-7">
                    <div class="card border-top border-0 border-4 border-brand">
                        <div class="card-body p-5">
                            <div class="card-title d-flex align-items-center">
                                <div><i class="bx bxs-user me-1 font-22 brand-color"></i>
                                </div>
                                <h5 class="mb-0"><span [translate]="'GREATER.VERSIONS'"> </span></h5>
                            </div>
                            <hr>
                            <form [formGroup]="staticData">
                                    <div class="col-6 pb-3">
                                        <label for="inputEmail" class="form-label d-block text-capitalize">{{ currentdetail[0].device}} <span [translate]="'GREATER.VERSION'"> </span></label>
                                        <input type="text" class="form-control" [id]="currentdetail[0]._id" [(ngModel)]="currentdetail[0].version" formControlName="version" [ngClass]="{ 'is-invalid': submitted && f.version.errors }" >
                                        <div *ngIf="submitted && f.version.errors" class="invalid-feedback">
                                            <span [translate]="'GREATER.VERSION_IS_REQUIRED'"> </span>
                                        </div>
                                    </div>
    
                                    <div class="col-6 btn-box pt-2 pb-5">
                                        <button type="submit" class="btn custom-btn brand-btn px-4 text-capitalize" (click)="Onsubmit(currentdetail[0]._id,1)"><span [translate]="'GREATER.UPDATE'"> </span> {{ currentdetail[0].device}} <span [translate]="'GREATER.VERSION'"> </span> </button>
                                    </div>
                                    <div class="col-6 pb-3">
                                        <label for="inputEmail" class="form-label d-block text-capitalize">{{ currentdetail[1].device}} <span [translate]="'GREATER.VERSION'"> </span></label>
                                        <input type="text" class="form-control" [id]="currentdetail[1]._id" [(ngModel)]="currentdetail[1].version" formControlName="version1" [ngClass]="{ 'is-invalid': submitted && f.version1.errors }" >
                                        <div *ngIf="submitted && f.version1.errors" class="invalid-feedback">
                                            <span [translate]="'GREATER.VERSION_IS_REQUIRED'"> </span>
                                        </div>
                                    </div>
                                     
                                    <div class="col-6 btn-box pt-2">
                                        <button type="submit" class="btn custom-btn brand-btn px-4 text-capitalize" (click)="Onsubmit(currentdetail[1]._id,2)"><span [translate]="'GREATER.UPDATE'"> </span> {{ currentdetail[1].device}} <span [translate]="'GREATER.VERSION'"> </span> </button>
                                    </div>
                            

                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <!--end row-->

        </div>
    </div>

    <app-footer></app-footer>
</div>

